import styled, { css } from 'styled-components';
import { mediaConfined, mediaWide } from '@xingternal/layout-tokens';
import { cornerRadiusS, scale010, scale080, scale100, spaceS, spaceXS, spaceXXS, xdlColorBackground, xdlColorControlFillTertiary, xdlColorInfo, xdlColorNotification, xdlColorPremium, xdlColorPricing, xdlColorProBusiness, xdlColorProJobs, xdlColorTextOnDark, xdlColorTextOnLight, xdlColorUserRoles, } from '@xingternal/tokens';
import { BodyCopy } from '@xingternal/typography';
// *** Base ***
const baseFlag = css `
  align-items: center;
  border-radius: ${cornerRadiusS};
  box-sizing: border-box;
  display: inline-flex;
  justify-content: center;
  margin: 0;
  text-decoration: none;
  user-select: none;
  white-space: nowrap;
`;
// *** Sizes ***
export const sizes = {
    small: css `
    border: ${scale010} solid transparent;
    border-radius: ${cornerRadiusS};
    height: ${scale080};
    padding: calc(${spaceXS} + ${spaceXXS});
  `,
    medium: css `
    border: ${scale010} solid transparent;
    border-radius: ${cornerRadiusS};
    height: ${scale100};
    padding: ${spaceS};
  `,
};
// *** Variants ***
export const variants = {
    ambassador: css `
    background-color: ${xdlColorUserRoles};
    color: ${xdlColorTextOnDark};
  `,
    basic: css `
    background-color: ${xdlColorControlFillTertiary};
    color: ${xdlColorTextOnLight};
  `,
    beta: css `
    background-color: ${xdlColorNotification};
    color: ${xdlColorTextOnDark};
  `,
    insider: css `
    background-color: ${xdlColorUserRoles};
    color: ${xdlColorTextOnDark};
  `,
    moderator: css `
    background-color: ${xdlColorUserRoles};
    color: ${xdlColorTextOnDark};
  `,
    new: css `
    background-color: ${xdlColorNotification};
    color: ${xdlColorTextOnDark};
  `,
    // DEPRECATED
    newsplus: css `
    background-color: ${xdlColorBackground};
    border-color: ${xdlColorPricing};
    color: ${xdlColorPricing};
  `,
    premium: css `
    background-color: ${xdlColorPremium};
    color: ${xdlColorTextOnDark};
  `,
    proBusiness: css `
    background-color: ${xdlColorProBusiness};
    color: ${xdlColorTextOnDark};
  `,
    proCoach: css `
    background-color: ${xdlColorPremium};
    color: ${xdlColorTextOnDark};
  `,
    proJobs: css `
    background-color: ${xdlColorProJobs};
    color: ${xdlColorTextOnDark};
  `,
    proTrainer: css `
    background-color: ${xdlColorPremium};
    color: ${xdlColorTextOnDark};
  `,
    // DEPRECATED
    local: css `
    background-color: ${xdlColorInfo};
    color: ${xdlColorTextOnDark};
  `,
};
// *** Components ***
const Flag = styled.span `
  ${baseFlag}
  ${({ $size }) => sizes[$size]}

  ${({ $sizeConfined }) => $sizeConfined &&
    css `
      @media ${mediaConfined} {
        ${sizes[$sizeConfined]};
      }
    `};

  ${({ $sizeWide }) => $sizeWide &&
    css `
      @media ${mediaWide} {
        ${sizes[$sizeWide]};
      }
    `};

  ${({ $variant }) => variants[$variant]}
`;
const Text = styled(BodyCopy) `
  align-items: center;
  display: flex;
  justify-content: center;
  line-height: 1;
`;
export const Styled = {
    Flag,
    Text,
};
//# sourceMappingURL=flag.styles.js.map